import * as React from 'react'

/**
 *     Import
 *     - Images
 */
import { AgentAdminIcon } from './AgentAdmin/AgentAdmin'
import { BrittleIcon } from './AssetsIcons/Brittle'
import { ClocksIcon } from './AssetsIcons/Clocks'
import { CollectiblesIcon } from './AssetsIcons/Collectibles'
import { FurnitureIcon } from './AssetsIcons/Furniture'
import { JewelleryIcon } from './AssetsIcons/Jewellery'
import { ObjetDartIcon } from './AssetsIcons/ObjetDart'
import { PaintingIcon } from './AssetsIcons/Painting'
import { RugsIcon } from './AssetsIcons/Rugs'
import { SculpturesIcon } from './AssetsIcons/Sculptures'
import { BinIcon } from './Bin/Bin'
import { CalendarIcon } from './Calendar/Calendar'
import { CogIcon } from './Cog/Cog'
import { DefaultPicture } from './DefaultPicture/DefaultPicture'
import { DropdownArrowIcon } from './DropdownArrow/DropdownArrow'
import { EditIcon } from './Edit/Edit'
import { ExitIcon } from './Exit/Exit'
import { InfoIcon } from './Info/Info'
import { LockIcon } from './Lock/Lock'
import { ManageIcon } from './Manage/Manage'
import { MarkerIcon } from './Marker/Marker'
import { MtaIcon } from './Mta/Mta'
import { NavBarIcon } from './NavBar/NavBar'
import { NotificationIcon } from './Notification/Notification'
import { PercentageIcon } from './Percentage/Percentage'
import { PlusIcon } from './Plus/Plus'
import { SearchIcon } from './Search/Search'
import { SpinnerIcon } from './Spinner/Spinner'
import { TickIcon } from './Tick/Tick'
import { UserIcon } from './User/User'
import { UserBlueIcon } from './User/UserBlue'
import { VerifiedIcon } from './Verified/Verified'
import { ViewIcon } from './View/View'

let styles = {
    display: 'block',
    float: 'left',
    padding: '10px',
    minHeight: '100px',
}

const Icons = () =>
    (
        <div style={{ display: 'table', padding: '30px' }}>
            <div style={{ display: 'table', padding: '10px' }}>
                <h1>Icons</h1>
                <div style={styles}>
                    <AgentAdminIcon />
                </div>
                <div style={styles}>
                    <BrittleIcon />
                </div>
                <div style={styles}>
                    <ClocksIcon />
                </div>
                <div style={styles}>
                    <CollectiblesIcon />
                </div>
                <div style={styles}>
                    <FurnitureIcon />
                </div>
                <div style={styles}>
                    <JewelleryIcon />
                </div>
                <div style={styles}>
                    <ObjetDartIcon />
                </div>
                <div style={styles}>
                    <PaintingIcon />
                </div>
                <div style={styles}>
                    <RugsIcon />
                </div>
                <div style={styles}>
                    <SculpturesIcon />
                </div>
                <div style={styles}>
                    <BinIcon />
                </div>
                <div style={styles}>
                    <CalendarIcon />
                </div>
                <div style={styles}>
                    <CogIcon />
                </div>
                <div style={styles}>
                    <DefaultPicture />
                </div>
                <div style={styles}>
                    <DropdownArrowIcon />
                </div>
                <div style={styles}>
                    <EditIcon />
                </div>
                <div style={styles}>
                    <ExitIcon />
                </div>
                <div style={styles}>
                    <InfoIcon />
                </div>
                <div style={styles}>
                    <LockIcon />
                </div>
                <div style={styles}>
                    <ManageIcon />
                </div>
                <div style={styles}>
                    <MarkerIcon />
                </div>
                <div style={styles}>
                    <MtaIcon />
                </div>
                <div style={styles}>
                    <NavBarIcon />
                </div>
                <div style={styles}>
                    <NotificationIcon />
                </div>
                <div style={styles}>
                    <PercentageIcon />
                </div>
                <div style={styles}>
                    <PlusIcon />
                </div>
                <div style={styles}>
                    <SearchIcon />
                </div>
                <div style={styles}>
                    <SpinnerIcon />
                </div>
                <div style={styles}>
                    <TickIcon />
                </div>
                <div style={styles}>
                    <UserIcon />
                </div>
                <div style={styles}>
                    <UserBlueIcon />
                </div>
                <div style={styles}>
                    <VerifiedIcon />
                </div>
                <div style={styles}>
                    <ViewIcon />
                </div>

            </div>
        </div>
    )

export default Icons



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Icons.tsx